import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { SidebarAdmin } from "./SidebarAdmin";
import styles from "./AdminLayout.module.css";
export const AdminLayout = ({ children }) => {
    return (_jsxs("div", { className: styles.appContainer, children: [_jsx(SidebarAdmin, {}), _jsx("main", { className: styles.mainContent, children: children })] }));
};
